import { POST_STAFF_CARDS_ERROR, POST_STAFF_CARDS_START, POST_STAFF_CARDS_SUCCESS } from '../../types';

export default function post_staff_cards(state, action) {
  switch (action.type) {
    case POST_STAFF_CARDS_START:
      return { ...state };
    case POST_STAFF_CARDS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_STAFF_CARDS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}